import React from "react";
import { useI18n } from "../i18n/I18nContext";

export default function LegalPageLayout({ tKey }) {
  const { t } = useI18n();
  const sections = t(`pages.${tKey}.sections`, []);
  return (
    <main
      className="bg-white"
      data-testid={`legal-page-${tKey}`}
    >
      <section className="border-b border-slate-200 bg-[#F5F3EF]">
        <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8">
          <p className="text-xs uppercase tracking-[0.2em] text-[#C56E4E]">
            Xorvyniq · Argentina
          </p>
          <h1 className="mt-4 font-serif text-4xl text-[#0B2447] sm:text-5xl">
            {t(`pages.${tKey}.title`)}
          </h1>
          <p className="mt-3 text-sm text-slate-600">
            {t(`pages.${tKey}.updated`)}
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-4 py-14 sm:px-6 sm:py-20 lg:px-8">
        <div className="space-y-10">
          {Array.isArray(sections) &&
            sections.map((s, idx) => (
              <article key={idx} data-testid={`legal-section-${tKey}-${idx}`}>
                <h2 className="font-serif text-2xl text-[#0B2447]">
                  {s.heading}
                </h2>
                <p className="mt-3 text-base leading-relaxed text-slate-700">
                  {s.body}
                </p>
              </article>
            ))}
        </div>
      </section>
    </main>
  );
}
